/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ClaimsSchemaOptional } from './ClaimsSchemaOptional';

export const CredentialSchemaUpdate: core.serialization.ObjectSchema<
    serializers.CredentialSchemaUpdate.Raw,
    Truvity.CredentialSchemaUpdate
> = core.serialization.object({
    schema: ClaimsSchemaOptional,
});

export declare namespace CredentialSchemaUpdate {
    export interface Raw {
        schema: ClaimsSchemaOptional.Raw;
    }
}
